import axiosSetup from "../utils/axiosSetup";
import toast from "react-hot-toast";

export const createBOM = async (bomData: any) => {
  try {
    const response = await axiosSetup.post(
      "/product/add-bill-of-material",
      bomData,
    );
    return response?.data?.data;
  } catch (error) {
    console.error("Failed to create BOM:", error);
    throw error;
  }
};

export const addItemsToBOM = async (bomId: string, items: any[]) => {
  try {
    const response = await axiosSetup.post(
      `/product/add-items-to-bom/${bomId}`,
      { items },
    );
    return response?.data?.data;
  } catch (error) {
    console.error("Failed to add items to BOM:", error);
    toast.error("Failed to add items to BOM");
    throw error;
  }
};

export const fetchAllBOMs = async (search?: string) => {
  try {
    const response = await axiosSetup.get("/product/get-all-boms", {
      params: {
        search: search?.trim() || undefined,
      },
    });
    return response?.data?.data;
  } catch (error) {
    console.error("Failed to fetch BOMs:", error);
    toast.error("Failed to fetch BOMs");
    throw error;
  }
};

export const updateBOM = async (bomId: string, bomData: any) => {
  try {
    const response = await axiosSetup.put(
      `/product/update-bom/${bomId}`,
      bomData,
    );
    return response?.data?.data;
  } catch (error) {
    console.error("Failed to update BOM:", error);
    toast.error("Failed to update BOM");
    throw error;
  }
};
